import { IJob } from "@types";

import { FC } from "react";
import Image from "next/image";

import { Box } from "../../atoms/Box";

const Job: FC<IJob> = ({
  company,
  jobTitle,
  fromDate,
  toDate,
  technologies,
  shortDescription,
  index,
}) => {
  return (
    <Box>
      <div className="flex flex-col md:flex-row flex-wrap justify-between text-center">
        <h2
          className={`text-xs font-semibold  mb-4 ${
            (index == 0 || index == 3) &&
            "underline underline-offset-4 decoration-wavy"
          }`}
        >
          Click on the box for full responsibilities*
        </h2>
        {(index == 0 || index == 3) && (
          <h2 className="text-xs font-semibold  mb-4 text-red-500 underline underline-offset-4 decoration-wavy"></h2>
        )}
      </div>
      <div className="mb-4 border md:mb-0 md:border-0"></div>
      <div className="flex gap-4 items-start md:items-center">
        {company.logo && (
          <Image
            src={company.logo}
            alt={company.name}
            width={64}
            height={64}
            className="rounded-md"
          />
        )}
        <div className="w-full mb-2">
          <div className="flex flex-col-reverse md:flex-row justify-between">
            <h3 className="font-bold">{jobTitle}</h3>
            <span className="text-sm md:text-base">
              {fromDate} - {toDate}
            </span>
          </div>
          <h4 className="text-sm font-normal">
            {company.url ? (
              <a
                href={company.url}
                target="_blank"
                rel="noopener noreferrer"
                className="underlined relative"
              >
                {company.name}
              </a>
            ) : (
              <>{company.name}</>
            )}
          </h4>
          <p className="hidden md:block text-sm">
            <strong>Technologies: </strong>
            {technologies.join(", ")}
          </p>
        </div>
      </div>
      <p className="md:hidden text-sm">
        <strong>Technologies: </strong>
        {technologies.join(", ")}
      </p>
      <ul className="ml-5 mt-2 list-disc">
        {shortDescription.map((item: String, index) => {
          return (
            <li key={index} className="leading-relaxed">
              {item}
            </li>
          );
        })}
      </ul>
    </Box>
  );
};

export { Job };
